import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaBook } from "react-icons/fa";
import LanguageSelector from "./LanguageSelector";

const ThemeToggle = () => {
  const [isDark, setIsDark] = useState(() =>
    typeof window !== "undefined"
      ? document.documentElement.classList.contains("dark")
      : false
  );

  useEffect(() => {
    if (isDark) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [isDark]);

  return (
    <button
      aria-label='Toggle dark mode'
      className='flex outline-none items-center justify-center w-10 h-10 rounded-lg border border-border bg-background text-foreground transition-colors shadow hover:bg-accent hover:text-accent-foreground focus:outline-none'
      onClick={() => setIsDark((d) => !d)}
    >
      {isDark ? (
        <svg
          width='20'
          height='20'
          fill='none'
          viewBox='0 0 24 24'
          stroke='currentColor'
          className='text-yellow-400'
        >
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            d='M12 3v1m0 16v1m8.66-13.66l-.71.71M4.05 19.07l-.71.71M21 12h-1M4 12H3m16.66 5.66l-.71-.71M4.05 4.93l-.71-.71M16 12a4 4 0 11-8 0 4 4 0 018 0z'
          />
        </svg>
      ) : (
        <svg
          width='20'
          height='20'
          fill='none'
          viewBox='0 0 24 24'
          stroke='currentColor'
          className='text-foreground'
        >
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            d='M21 12.79A9 9 0 1111.21 3a7 7 0 109.79 9.79z'
          />
        </svg>
      )}
    </button>
  );
};

const Navbar = () => {
  return (
    <>
      <nav className='fixed top-0 w-full max-wscreen z-20 bg-transparent'>
        <div className='flex w-full gap-5 p-2 items-end justify-end'>
          <Link
            to='/translations'
            aria-label='Translations'
            className='flex outline-none items-center justify-center w-10 h-10 rounded-lg border border-border bg-background text-foreground transition-colors shadow hover:bg-accent hover:text-accent-foreground focus:outline-none'
          >
            <FaBook />
          </Link>
          <LanguageSelector />
          <ThemeToggle />
        </div>
      </nav>
    </>
  );
};
export default Navbar;
